import React from 'react';
import Title from "../components/Title";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import createLink from "../../libs/createLink";
import Helmet from "react-helmet";


const Terms = (props) => {
    window.scrollTo(0, 0);
    return (
        <div id="terms">
            <Helmet>
                <title>{config.preTitle}Charte d'utilisation{config.postTitle}</title>
                <link rel="canonical" href={canonical(createLink("cgus"), "", "cgus")} />
            </Helmet>
            <div className="container">
                <div className="card big">
                    <Title heading={"heading-1"} display={"display-2"}>Conditions d'utilisation des services Voissa
                        (CGUS)</Title>
                    <div className="voissa-terms-block">
                        <h3>ACCEPTATION DES CONDITIONS GENERALES</h3>
                        <p>Le site Voissa.com, ses fonctionnalités et services (ci-après conjointement dénommés
                            "Voissa") appartiennent à la société Cédrat Net. Voissa est accessible sur internet ou
                            d'autres supports de communication électronique à partir d'un ordinateur, d'une tablette,
                            d'un téléphone, etc.. L'utilisation de Voissa est régie par les présentes Conditions
                            Générales d'Utilisation du Service (ci-après dénommées les "CGUS"). Les CGUS qui
                            s'appliquent à tout utilisateur qu'il se soit enregistré sur Voissa (ci-après dénommé "le
                            Voissanaute") ou non (ci-après dénommé l' "invité"). L'utilisation de Voissa implique
                            nécessairement l'acceptation des présentes CGUS. En conséquence, tout utilisateur de Voissa
                            déclare et accepte avoir accepté les CGUS.</p>

                        <p>Cédrat Net se réserve le droit de modifier ou de mettre à jour les CGUS sans avoir à en
                            prévenir les utilisateurs ni à leur demander leur accord.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>PRESENTATION DE VOISSA</h3>
                        <p>La communauté formée par les Voissanautes (ci-après dénommée la "communauté Voissa") est
                            ouverte à toutes les personnes majeures (plus de 18 ans) disposant d'une adresse email
                            valide.</p>

                        <p>Les fonctionnalités inclues dans Voissa et proposées à la communauté Voissa sont des services
                            et moyens d'expression et notamment des forums, blogs, galeries photos, vidéos et un
                            magazine auxquels les Voissanautes peuvent contribuer et sur lesquels ils peuvent
                            échanger.</p>

                        <p>- Voissa propose sur ses forums des espaces de discussions, d'échanges et d'entraide destinés
                            à l'épanouissement sexuel.</p>
                        <p>- Voissa fournit aussi à chacun des Voissanautes les outils permettant la création et
                            l'administration d'un blog, hébergé sur la plateforme Voissa.</p>
                        <p>- Voissa comprend également des fonctionnalités permettant aux Voissanautes de télécharger,
                            stocker, partager et commenter leurs vidéos et photos personnelles.</p>
                        <p>- Voissa propose un magazine en hommage à ses membres qui met en avant régulièrement les
                            photos, les discussions et les récits de certains Voissanautes.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>PROPRIETE INTELLECTUELLE DU CONTENU PUBLIE PAR LES VOISSANAUTES</h3>
                        <p>Tout Voissanaute déclare et accepte qu'en publiant sur l'une des fonctionnalités ou services
                            de Voissa via son compte ses photos, vidéos, histoires, etc. (ci-après dénommés le
                            "Contenu") il accorde à Cédrat Net une licence gratuite sur le Contenu qui permet de le
                            rendre accessible et téléchargeable à d'autres Voissanautes et Invités sur l'intégralité des
                            fonctionnalités et services Voissa et sur tout support publicitaire destiné à améliorer la
                            visibilité de Voissa et de la communauté Voissa. Parallèlement, tout Voissanaute déclare et
                            accepte qu'en publiant sur l'une des fonctionnalités ou services de Voissa via son compte le
                            Contenu, il concède aux Voissanautes et aux Invités pour toute la durée de l'hébergement du
                            contenu sur Voissa le droit de visualiser le contenu à titre gratuit et à des fins
                            exclusivement personnelles sur Voissa concédés, ainsi que le droit de télécharger/visualiser
                            le Contenu sur d'autres supports pour la durée maximale de protection des droits y
                            afférents.</p>

                        <p>Pendant la durée de l'hébergement du Contenu et dans le strict cadre des fonctionnalités
                            permettant de rendre accessible sur Voissa via internet ou d'autres supports de
                            communications électroniques, vous nous autorisez à reproduire/représenter votre contenu et,
                            en tant que de besoin, en adapter le format à cet effet. Vous êtes par ailleurs informé que,
                            compte tenu des caractéristiques intrinsèques de l'internet, les données transmises,
                            notamment votre contenu, ne sont pas protégées contre les risques de détournement et/ou de
                            piratage, ce dont nous ne saurions être tenus responsables. Il vous appartient, le cas
                            échéant, de prendre toutes les mesures appropriées de façon à protéger ces données.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>PROPRIETE INTELLECTUELLE DE CEDRAT NET</h3>
                        <p>Voissa est la propriété exclusive de Cédrat Net. D'une manière générale, nous vous accordons
                            un droit gratuit, personnel, non-exclusif et non-transférable d'accès et d'utilisation de
                            Voissa, tout autre droit étant expressément exclu sans notre accord préalable écrit.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>PROPRIETE INTELLECTUELLE DE CEDRAT NET</h3>
                        <p>Nous ne sommes légalement tenus à aucune obligation générale de surveillance du contenu
                            transmis ou stocké via et sur Voissa. Les seules obligations inhérentes à notre qualité
                            d'hébergeur concernent la lutte contre l'apologie des crimes contre l'humanité, l'incitation
                            à la haine raciale, la pornographie enfantine, la conservation de vos données de connexion,
                            par ailleurs couvertes par le secret professionnel et traitées dans le respect des
                            dispositions légales en matière de Données Personnelles et le retrait de tout contenu
                            manifestement illicite, dès lors que nous en aurons eu effectivement connaissance.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>VOTRE RESPONSABILITE DE VOISSANAUTE</h3>
                        <p>En votre qualité de fournisseur de contenu de Voissa, qu'il s'agisse de vidéos, de photos ou
                            de commentaires que vous y apportez, vous êtes tenus au respect des dispositions légales et
                            réglementaires en vigueur. Il vous appartient en conséquence de vous assurer que le stockage
                            et la diffusion du Contenu via et sur Voissa ne constitue pas une violation des droits de
                            propriété intellectuelle de tiers (document multimédia que vous n'avez pas réalisés
                            personnellement ou pour lesquels vous ne disposez pas des autorisations nécessaires des
                            tiers titulaires de droits sur ceux-ci), une atteinte aux personnes (notamment diffamation,
                            insultes, injures, etc...) et au respect de la vie privée, une atteinte à l'ordre public et
                            aux bonnes mœurs (notamment, apologie des crimes contre l'humanité, incitation à la haine
                            raciale, pornographie enfantine, etc...). A défaut, le contenu sera retiré dans les
                            conditions visées au paragraphe 5 et/ou votre compte sera désactivé sans formalité
                            préalable. En outre, vous encourrez, à titre personnel, les sanctions pénales spécifiques au
                            contenu litigieux (peines d'emprisonnement et amende), outre la condamnation éventuelle au
                            paiement de dommages et intérêts. Compte tenu du caractère communautaire de Voissa et par
                            respect pour les sensibilités de chacun, il appartient au Voissanaute de conserver une
                            certaine éthique quant aux photos, vidéos et/ou commentaires mis en ligne et, notamment, de
                            s'abstenir de diffuser tout contenu à caractère violent.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>VOTRE RESPONSABILITE DE VOISSANAUTE</h3>
                        <p>Aux fins de bénéficier de l'ensemble de Voissa, vous devez créer un compte au moyen du
                            formulaire en ligne prévu à cet effet. Vous demeurez à tout moment libre de modifier la
                            teneur des Données Personnelles communiquées à cette occasion. En remplissant le formulaire
                            vous déclarez remplir les conditions d'inscription à Voissa et notamment être majeur. Dès
                            validation du formulaire, vous recevrez un courrier électronique vous invitant à cliquer sur
                            un lien aux fins de confirmer votre inscription. L'accès à votre compte peut s'effectuer par
                            saisie de votre identifiant et mot de passe associé, dont vous assurez seul la
                            confidentialité. Nous attirons votre attention sur la nécessité de préserver cette
                            confidentialité, tout Contenu publié à partir de votre Compte pouvant engager votre
                            responsabilité personnelle. L'utilisation de Voissa suivant votre inscription est valable
                            pour une durée indéterminée. Nous nous réservons la possibilité d'y mettre fin à tout
                            moment, par courrier électronique, moyennant un préavis raisonnable. En cas de non-respect
                            des obligations inhérentes à votre responsabilité ci-avant, l'accès à votre espace personnel
                            peut être, immédiatement et sans préavis, temporairement ou définitivement suspendu au moyen
                            de la désactivation de votre compte et ce, sans préjudice de nos autres droits.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>DISPONIBILITE DE VOISSA</h3>
                        <p>Voissa est par principe accessible 24/24h, 7/7j, sauf interruption, programmée ou non, pour
                            les besoins de sa maintenance ou cas de force majeure. Etant de fait soumis à une obligation
                            de moyens, nous ne saurions être tenus responsable de tout dommage, quelle qu'en soit la
                            nature, résultant d'une indisponibilité de Voissa.</p>
                    </div>

                    <div className="voissa-terms-block">
                        <h3>DROIT APPLICABLE ET ATTRIBUTION DE COMPETENCES</h3>
                        <p>Les CGUS constituent un accord total entre Cédrat Net et les utilisateurs de Voissa et
                            définissent l'utilisation du Service par les Voissanautes et les Invités. Les CGUS
                            disponibles sur le site Voissa.com prévalent sur tout accord antérieur entre Cédrat Net et
                            les Voissanautes (y compris, sans que cela soit limitatif, sur toute version antérieure des
                            CGUS). Ces CGUS sont régies par la loi française.</p>

                        <p>En cas de litige ou de contestation sur l'interprétation, l'exécution ou la réalisation d'un
                            des articles des présentes CGUS et à défaut d'accord amiable entre les parties, le tribunal
                            de Paris (France) sera le seul compétent.</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Terms;
